import { DSLLoader } from '../dsl/DSLLoader';
import { resolveText } from '../i18n/resolveText';
// The salon's admin contacts (names, phones, email) live in exactly one place:
// the home page's `contacts` block in public/content/home.json — the same
// source the site's contacts section and the server's emails
// (email.mjs → getPublicContacts) read. Fetched once and shared by every
// modal that lists them.
const contentLoader = new DSLLoader();
let contactsPromise = null;
function loadPublicContacts() {
    if (!contactsPromise) {
        contactsPromise = contentLoader.load('home').then((page) => {
            const block = page.blocks.find((candidate) => candidate.type === 'contacts');
            if (!block)
                throw new Error('home.json has no contacts block');
            return block;
        });
        // Let a failed fetch be retried the next time a modal opens.
        contactsPromise.catch(() => {
            contactsPromise = null;
        });
    }
    return contactsPromise;
}
// Returns the contacts list element right away (modals are built
// synchronously) and fills it with one link line per phone plus the email
// once the content is loaded — instantly after the first load, since the
// block is cached. `listClassName`/`lineClassName` keep each screen's own
// styling (booking__modal-* / profile__modal-*).
export function createAdminContactsList(listClassName, lineClassName) {
    const list = document.createElement('div');
    list.className = listClassName;
    const appendLine = (href, text) => {
        const link = document.createElement('a');
        link.href = href;
        link.textContent = text;
        const line = document.createElement('p');
        line.className = lineClassName;
        line.appendChild(link);
        list.appendChild(line);
    };
    loadPublicContacts()
        .then((contacts) => {
        for (const phone of contacts.phones) {
            appendLine(phone.href, `${resolveText(phone.name)}: ${phone.phone}`);
        }
        appendLine(`mailto:${contacts.email}`, contacts.email);
    })
        .catch((err) => {
        console.error('Failed to load admin contacts:', err);
    });
    return list;
}
